module.exports = __webpack_public_path__ + "img/loading.47f6ffc4.gif";